import { Button, Stack, Typography } from "@mui/material";
import { useFieldArray, UseFormReturn } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import withDragDropContext from "hocs/withDragDropContext";
import { QuestionInputs } from "../../types";
import CheckboxesList from "./components/CheckboxesList";

const CheckboxesListWithDragDropContext = withDragDropContext(CheckboxesList);

export interface MultiChoiceBlockProps {
  form: UseFormReturn<QuestionInputs>;
  isEditing: boolean;
}

const MultiChoiceBlock = ({ form, isEditing }: MultiChoiceBlockProps) => {
  const { control } = form;
  const { fields, append, remove, move } = useFieldArray({
    control,
    keyName: "formId",
    name: "partsInput",
  });

  const appendCheckbox = () => {
    append({ content: "", isCorrect: false });
  };

  const removeCheckbox = (index: number) => {
    remove(index);
  };

  return (
    <Stack spacing={0.5}>
      <Typography
        variant='body14rg'
        sx={{ color: "base.500" }}>
        Варинаты ответов
      </Typography>
      <Stack spacing={2}>
        <CheckboxesListWithDragDropContext
          droppableId='questionCheckboxesList'
          moveItems={move}
          fields={fields}
          removeCheckbox={removeCheckbox}
          isEditing={isEditing}
        />
      </Stack>
      <Button
        sx={{ width: "fit-content" }}
        startIcon={<AddIcon />}
        disabled={!isEditing}
        onClick={appendCheckbox}>
        Добавить вариант ответа
      </Button>
    </Stack>
  );
};

export default MultiChoiceBlock;
